import rules from "../rules";

export default {
    first_name: [
        rules.required('First name')
    ],
    last_name: [
        rules.required('Last name')
    ],
    address_primary: [
        rules.required('Primary address')
    ],
    city: [
        rules.required('City'),
    ],
    province: [
        rules.required('Province'),
    ],
    postal_code: [
        rules.required('Postal Code'),
    ],
    country: [
        (p, model) => {
            return !model.is_international_customer || (!!p || 'Country is required for international customers!');
        }
    ],
    phone: [
        rules.required('Phone')
    ],
    email: [
        rules.required('Email'),
        (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || 'Enter valid email'
    ],
    email_confirmation: [
        rules.required('Email confirmation'),
        (email, model) => (email === model.email || (model.reservation && email === model.reservation.email)) || 'Emails doesn\'t match'
    ],
    date_pickup: [
        (date, model) => !!(!!date || (model.is_seasonal || (model.reservation &&  model.reservation.is_seasonal) ) || (model.is_group || (model.reservation &&  model.reservation.is_group))) || 'Start day is required'

    ],
    date_return: [
        (date, model) => !!(!!date || (model.is_seasonal || (model.reservation &&  model.reservation.is_seasonal)) || (model.is_group || (model.reservation &&  model.reservation.is_group))) || 'End day is required'
    ],
    reservees_number: [
        rules.required('Number of renters')
    ],
}
